import { lazy } from 'react';

import usePdfScenarioDetail from './usePdfScenarioDetail';

const ScenarioDetail = lazy(() => import('./ScenarioDetail'));
const ScenarioDetailTable = lazy(() => import('./ScenarioDetailTable'));

export { ScenarioDetail, ScenarioDetailTable, usePdfScenarioDetail };
